import React, { Component } from 'react'
import cx from 'classnames'
import uuidv4 from 'uuid/v4'
import { Select, Input } from 'antd'
import za from 'za-helper'
import { ZAEnv, ZARef } from 'za-react'
import 'antd/es/select/style/index.css'
import Form from '~/components/Form'
import Module from '~/components/Module'
import Button from '~/components/Button'
import SVG from '~/components/SVG'
import { universalToast } from '~/utils'
import { saveSales } from '~/services'
import currencyIcon from '~/assets/icon-currency.svg'
import subFailure from '~/assets/sub-fail.png'
import subSuccess from '~/assets/sub-success.png'
import styles from './index.css'

const MODAL_STATUS = {
  FAILURE: 0,
  SUCCESS: 1,
}

const SUBMIT_RES_IMAGE_MAP = {
  0: subFailure,
  1: subSuccess,
}

const FORM_FIELD_MAP = {
  name: '姓名',
  phone: '电话',
  age: '年龄',
}

const AGE_OPTIONS = ['18-30岁', '30-40岁', '40-50岁', '50岁以上']

export default class Index extends Component {
  state = {
    name: '',
    phone: '',
    modalShow: false,
    modalType: MODAL_STATUS.SUCCESS,
  }

  componentWillUnmount = () => {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  handleChange = type => {
    return e => this.setState({ [type]: e.target.value })
  }

  handleSelect = type => {
    return value => this.setState({ [type]: value })
  }

  handleModalShow = type => {
    this.setState({ modalShow: true, modalType: type }, () => {
      this.timer = setTimeout(() => {
        this.setState({ modalShow: false })
      }, 2000)
    })
  }

  handleSubmit = () => {
    za.trackEvent(this, { id: 2047 })
    // eslint-disable-next-line no-unused-expressions

    this.zaRef.current.trackEvent({
      eventType: 'Click',
      action: 'OpenUrl',
      elementLocation: { type: 'Button' },
    })
    let errMsg = null

    Object.keys(FORM_FIELD_MAP).forEach(i => {
      if (!this.state[i]) {
        const fieldName = FORM_FIELD_MAP[i]
        errMsg = errMsg ? `${errMsg}、${fieldName}` : `请填写${fieldName}`
      }
    })

    const { name, phone, age } = this.state

    if (errMsg) {
      universalToast(errMsg, 'fail')
    } else {
      saveSales({ name, phone, age })
        .then(() => {
          this.handleModalShow(MODAL_STATUS.SUCCESS)
        })
        .catch(() => {
          this.handleModalShow(MODAL_STATUS.FAILURE)
        })
    }
  }
  zaRef = React.createRef()
  render() {
    const { msgCollectName, msgCollectPhone } = this.props
    const { name, phone, age, modalShow, modalType } = this.state

    return (
      <Module
        contentClassName={styles.formBody}
        headerIcon={<SVG src={currencyIcon} width={14} height={14} />}
        headerText={msgCollectName}
      >
        <Form.FormField label="姓名">
          <Input
            style={{ height: '40px' }}
            placeholder="请输入姓名"
            value={name}
            onChange={this.handleChange('name')}
            height={40}
          />
        </Form.FormField>
        <Form.FormField label="电话">
          <Input
            style={{ height: '40px' }}
            placeholder="请输入电话"
            value={phone}
            onChange={this.handleChange('phone')}
          />
        </Form.FormField>
        <Form.FormField
          contentClassName={styles.formAgeSelectWrap}
          label="年龄"
        >
          <Select
            placeholder="请选择年龄"
            value={age}
            onChange={this.handleSelect('age')}
          >
            {AGE_OPTIONS.map(ageOption => (
              <Select.Option
                key={`ageoption_${uuidv4()}`}
                className={styles.fromAgeOption}
                value={ageOption}
              >
                {ageOption}
              </Select.Option>
            ))}
          </Select>
        </Form.FormField>
        <Form.FormField>
          <ZAEnv block="activityCardButton">
            <ZARef ref={this.zaRef} />
            <Button
              className={styles.formSubmitButton}
              onClick={this.handleSubmit}
            >
              提交
            </Button>
          </ZAEnv>
        </Form.FormField>
        <div className={styles.formHotPhone}>
          报名热线：<span>{msgCollectPhone}</span>
        </div>
        <div
          className={cx(styles.formModal, {
            [styles.formModalShown]: modalShow,
          })}
        >
          <img src={SUBMIT_RES_IMAGE_MAP[modalType]} alt="" />
        </div>
      </Module>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Conversion/Form/index.js